module.exports = __webpack_public_path__ + "img/green-checkmark.e089f3a0.svg";